import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import {
  AppNoticeListDTO,
  AppNoticeDTO,
  FAQListDTO,
  FAQDTO,
  InquiryListDTO,
  InquiryDTO,
  PushNotificationListDTO,
  PushNotificationDTO,
  ForbiddenWordListDTO,
  ForbiddenWordDTO,
  BlockedUserListDTO,
  BlockedUserDTO,
} from '../dto/OperationSettingsDTOs';
import { genNoobookHeader } from './Common';

/**
 * 앱 공지 목록 조회
 * @param authToken 인증 토큰
 * @param startDate 시작일 (YYYY-MM-DD, 선택)
 * @param endDate 종료일 (YYYY-MM-DD, 선택)
 * @param ageGroup 연령대별 필터 (선택)
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getAppNoticeList(
  authToken: string,
  startDate?: string,
  endDate?: string,
  ageGroup?: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<AppNoticeListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (ageGroup) params.ageGroup = ageGroup;

  return ApiComm.getData<ResponseDTO<AppNoticeListDTO>>(
    '/admin/v1/notices',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockNotices: AppNoticeDTO[] = [
        {
          noticeNo: 1,
          title: '베너광 공지사항 등록',
          registrationDate: '2022-10-10',
          status: 'PUBLISHED',
        },
        {
          noticeNo: 2,
          title: '베너광고 징라요 의욕',
          registrationDate: '2022-10-10',
          status: 'HIDDEN',
        },
        {
          noticeNo: 3,
          title: '베너광고 성활 수 공직 제목',
          registrationDate: '2022-10-10',
          status: 'APPROVED',
        },
      ];

      const mockData: AppNoticeListDTO = {
        notices: mockNotices,
        page: {
          current: page,
          last: 1,
          total: 3,
        },
      };

      const response: ResponseDTO<AppNoticeListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300);
  });
}

/**
 * FAQ 목록 조회
 * @param authToken 인증 토큰
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getFAQList(
  authToken: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<FAQListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };

  return ApiComm.getData<ResponseDTO<FAQListDTO>>(
    '/admin/v1/faqs',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockFAQs: FAQDTO[] = [];

      const mockData: FAQListDTO = {
        faqs: mockFAQs,
        page: {
          current: page,
          last: 1,
          total: 0,
        },
      };

      const response: ResponseDTO<FAQListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 1:1 문의 목록 조회
 * @param authToken 인증 토큰
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getInquiryList(
  authToken: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<InquiryListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };

  return ApiComm.getData<ResponseDTO<InquiryListDTO>>(
    '/admin/v1/inquiries',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockInquiries: InquiryDTO[] = [
        {
          inquiryNo: 1,
          inquiryTypeTitle: '문의 유형 미답변 반들...',
          author: '작성자',
          registrationDate: '2022-11-17',
          status: 'PENDING',
        },
        {
          inquiryNo: 2,
          inquiryTypeTitle: '문의 유형 자압한 입력...',
          author: '작성자',
          registrationDate: '2022-11-17',
          status: 'PENDING',
        },
        {
          inquiryNo: 3,
          inquiryTypeTitle: '문의 유형 미리썸 염석...',
          author: '작성자',
          registrationDate: '2022-11-17',
          status: 'PENDING',
        },
      ];

      const mockData: InquiryListDTO = {
        inquiries: mockInquiries,
        unansweredCount: 5,
        page: {
          current: page,
          last: 1,
          total: 3,
        },
      };

      const response: ResponseDTO<InquiryListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 푸시 알림 목록 조회
 * @param authToken 인증 토큰
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getPushNotificationList(
  authToken: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<PushNotificationListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };

  return ApiComm.getData<ResponseDTO<PushNotificationListDTO>>(
    '/admin/v1/push-notifications',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockNotifications: PushNotificationDTO[] = [
        {
          pushNo: 1,
          title: '푸시 알림',
          content: '발송 내용 내용',
          sendDateTime: '2022-07-10 10:00',
          target: '타겟',
          status: 'SCHEDULED',
        },
      ];

      const mockData: PushNotificationListDTO = {
        notifications: mockNotifications,
        page: {
          current: page,
          last: 1,
          total: 1,
        },
      };

      const response: ResponseDTO<PushNotificationListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 금지어 목록 조회
 * @param authToken 인증 토큰
 */
export function getForbiddenWordList(
  authToken: string
): Promise<ResponseDTO<ForbiddenWordListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.getData<ResponseDTO<ForbiddenWordListDTO>>(
    '/admin/v1/forbidden-words',
    {},
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockWords: ForbiddenWordDTO[] = [
        { wordNo: 1, word: '금지어' },
        { wordNo: 2, word: '감금어' },
        { wordNo: 3, word: '이브어' },
      ];

      const mockData: ForbiddenWordListDTO = {
        words: mockWords,
      };

      const response: ResponseDTO<ForbiddenWordListDTO> = {
        errorCode: 0,
        response: mockData,
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 금지어 추가
 * @param authToken 인증 토큰
 * @param word 금지어
 */
export function addForbiddenWord(
  authToken: string,
  word: string
): Promise<ResponseDTO<any>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.postData<ResponseDTO<any>>(
    '/admin/v1/forbidden-words',
    { word },
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const response: ResponseDTO<any> = {
        errorCode: 0,
        response: { success: true },
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };
      resolve(response);
    }, 300);
  });
}

/**
 * 금지어 삭제
 * @param authToken 인증 토큰
 * @param wordNo 금지어 번호
 */
export function deleteForbiddenWord(
  authToken: string,
  wordNo: number
): Promise<ResponseDTO<any>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.deleteData<ResponseDTO<any>>(
    `/admin/v1/forbidden-words/${wordNo}`,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const response: ResponseDTO<any> = {
        errorCode: 0,
        response: { success: true },
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };
      resolve(response);
    }, 300);
  });
}

/**
 * 차단 사용자 목록 조회
 * @param authToken 인증 토큰
 * @param searchKeyword 검색 키워드 (차단 사유, 선택)
 * @param page 페이지 번호 (기본값: 1)
 * @param size 페이지 크기 (기본값: 10)
 */
export function getBlockedUserList(
  authToken: string,
  searchKeyword?: string,
  page: number = 1,
  size: number = 10
): Promise<ResponseDTO<BlockedUserListDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {
    page: page,
    size: size,
  };
  if (searchKeyword) params.searchKeyword = searchKeyword;

  return ApiComm.getData<ResponseDTO<BlockedUserListDTO>>(
    '/admin/v1/blocked-users',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockUsers: BlockedUserDTO[] = [
        {
          blockNo: 1,
          userId: 'dans01',
          blockReason: '차단일',
          blockDate: '2022-07-11',
        },
        {
          blockNo: 2,
          userId: 'horel03',
          blockReason: '차단일',
          blockDate: '2022-07-11',
        },
      ];

      const mockData: BlockedUserListDTO = {
        users: mockUsers,
        page: {
          current: page,
          last: 1,
          total: 2,
        },
      };

      const response: ResponseDTO<BlockedUserListDTO> = {
        errorCode: 0,
        response: mockData,
        page: mockData.page,
      };

      resolve(response);
    }, 300);
  });
}

/**
 * 차단 사용자 해제
 * @param authToken 인증 토큰
 * @param blockNo 차단 번호
 */
export function unblockUser(
  authToken: string,
  blockNo: number
): Promise<ResponseDTO<any>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  return ApiComm.postData<ResponseDTO<any>>(
    `/admin/v1/blocked-users/${blockNo}/unblock`,
    {},
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환
  return new Promise((resolve) => {
    setTimeout(() => {
      const response: ResponseDTO<any> = {
        errorCode: 0,
        response: { success: true },
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };
      resolve(response);
    }, 300);
  });
}
